import { createSelector } from '@reduxjs/toolkit';

import { ReduxState } from 'redux/root-reducer';

const selectGroupsState = (state: ReduxState) => state.groups;

export const selectGroups = createSelector(selectGroupsState, (groups) => groups.groups);

export const selectGroupsHasMore = createSelector(selectGroupsState, (groups): boolean => groups.hasMore);

export const selectGroupsIsLoading = createSelector(selectGroupsState, (groups) => groups.isLoading);

export const selectGroupApiError = (state: ReduxState) => state.groups.apiError;
